// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"optionalInformation_wrapper__Gb_db"};